import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Reset14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M5.03032 2.03033L3.96966 0.969666L0.939331 4L3.96966 7.03033L5.03032 5.96967L3.81066 4.75H9C10.7949 4.75 12.25 6.20507 12.25 8C12.25 9.79493 10.7949 11.25 9 11.25H5V12.75H9C11.6234 12.75 13.75 10.6234 13.75 8C13.75 5.37665 11.6234 3.25 9 3.25H3.81065L5.03032 2.03033Z'
      fill='currentColor'
    />
  </Svg>
);

Reset14.displayName = 'Reset14';
export default Reset14;
